export default "__VITE_ASSET__Bhbr7XP3__"